import React, { useContext, useRef, useState } from "react";
import { FilterArea, Barchart, DataTable, Alert, DataQuality, DataQualityLegend } from "@sia/style-guide";
import { useBreakPoint } from "@sia/style-guide/dist/common/useBreakPoint";
import { usePageRefresh } from "../tools";
import { companyHasOwnValues, parseBarchartData, parseTableData, getKeyFiguresPageQuality } from "./data/dataParsing";

import { MasterKeyContext } from "contexts/MasterKeyContext";
import { generateBarchartOptions, generateHeaderRows } from "./helper";
import "./KeyFiguresPage.scss";
import "katex/dist/katex.min.css";
import { getExplanatoryText } from "./explanatory_texts";
import GlobalContext from "contexts/GlobalContext";
export default function KeyFiguresPage({ translate, filters, setFilters, data, selectedTab, setSelectedTab }) {
  const KEYFIGURES_PAGE_TAB_INDEX = 3;
  usePageRefresh(selectedTab, KEYFIGURES_PAGE_TAB_INDEX, setSelectedTab);

  const { isMasterKeyValid } = useContext(MasterKeyContext);
  const { language } = useContext(GlobalContext);
  const { isMobile } = useBreakPoint();
  const [explicitHeight, setExplicitHeight] = useState("0px");
  const containerRef = useRef(null);

  const [alertState, setAlertState] = useState({ open: false, heading: "", message: "", index: 0 });

  const onRenderCompleted = () => {
    if (containerRef.current) {
      let horizontalBarChartHeight = containerRef.current.clientHeight;
      let verticalBarChartDataHeight = horizontalBarChartHeight + "px";
      setExplicitHeight(verticalBarChartDataHeight);
    }
  };

  if (data.length === 0) {
    return null;
  }

  let hasOwnValues = companyHasOwnValues(data);

  hasOwnValues = hasOwnValues && !!isMasterKeyValid;

  let verticalBarChartData = parseBarchartData(data, 0, 2, translate, hasOwnValues);
  let horizontalBarChartData = parseBarchartData(data, 3, null, translate, hasOwnValues);
  let vOptions = generateBarchartOptions(translate, isMobile, true);
  let hOptions = generateBarchartOptions(translate, isMobile, false);
  let tableHeaders = generateHeaderRows(translate, null, hasOwnValues);
  let tableData = parseTableData(data, hasOwnValues, setAlertState);
  let pageQuality = getKeyFiguresPageQuality(data);

  return (
    <div className="benchmarking-key-container sia-padding-02-left sia-padding-02-right">
      <p className="key-figures-title sia-text-15 sia-padding-06-top sia-padding-06-bottom">
        {translate("benchmarking.evaluations.key-figures.title")}
      </p>
      {filters && (
        <FilterArea
          translate={translate}
          initialFilters={filters}
          onFiltersUpdate={(filterAreaState) => {
            setFilters((state) => ({ ...state, filters: filterAreaState, newest: true }));
          }}
        />
      )}
      {pageQuality && (
        <div className="sia-key-figures-page-quality sia-padding-05-bottom">
          <DataQuality
            translate={translate}
            numberOfRecords={pageQuality.count}
            coefficient={pageQuality.coefficientOfVariation}
            label={"benchmarking.components.dataquality.number-of-records"}
          />
        </div>
      )}
      <div className="sia-key-page-chart-container">
        <div>
          <Barchart data={verticalBarChartData} translate={translate} options={vOptions} isVertical={true} explicitHeight={explicitHeight} />
        </div>
        <div ref={containerRef}>
          <Barchart data={horizontalBarChartData} bandWidth={100} translate={translate} options={hOptions} onRenderCompleted={onRenderCompleted} />
        </div>
      </div>
      <div id="keyPageTable" className="sia-key-page-table-container">
        <div className="sia-padding-05-top sia-boxplot-table">
          <DataTable headerRows={tableHeaders} dataRows={tableData} />
        </div>
      </div>
      {alertState.open && (
        <Alert
          open={alertState.open}
          alertHeading={alertState.heading}
          alertMessage={getExplanatoryText(alertState.index, language)}
          onRequestClose={() => setAlertState((previouState) => ({ ...previouState, open: false }))}
        />
      )}
      <DataQualityLegend translate={translate} />
    </div>
  );
}
